import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import DOMPurify from 'dompurify';
import logger from '../../utils/logger';

const HelpContent = () => {
  const { id } = useParams(); // Get the article ID from URL
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const docRef = doc(db, "articles", id); // "articles" is the Firestore collection
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setArticle(docSnap.data());
        } else {
          logger.warn("No such document!");
        }
      } catch (error) {
        logger.error("Error fetching document: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900">{article?.title}</h1>
        <div className="mt-6 prose prose-lg text-gray-700">
          {/* Sanitize HTML content to prevent XSS attacks */}
          <div dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(article?.content || '', {
              ALLOWED_TAGS: ['p', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code', 'pre', 'blockquote', 'br', 'hr', 'img', 'span', 'div'],
              ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'class']
            })
          }}></div>
        </div>
      </div>
    </div>
  );
};

export default HelpContent;
